<div id="users-loading" class="p-4" *ngIf="loading">
	<i class="fas fa-spinner fa-spin"></i>
	<span>Cargando usuarios...</span>
</div>

<div id="users" class="p-4" *ngIf="!loading">

	<h2>Administración de usuarios</h2>

	<div id="users-filters" class="mb-3">
		<label for="users-org-filter" class="me-3">
			<p class="fw-bold">Filtrar por organización:</p>
			<select id="users-org-filter" class="form-select" [(ngModel)]="searchOrg" (ngModelChange)="getUsers(searchOrg, searchRole, searchName)">
				<option selected value="0">Ninguna</option>
				<option *ngFor="let org of orgs" [value]="org.id">
					{{ org.name }}
				</option>
			</select>
		</label>

		<label for="users-role-filter" class="me-3">
			<p class="fw-bold">Filtrar por rol:</p>
			<select id="users-role-filter" class="form-select" [(ngModel)]="searchRole" (ngModelChange)="getUsers(searchOrg, searchRole, searchName)">
				<option selected value="0">Ninguno</option>
				<option *ngFor="let role of roles" [value]="role.id">
					{{ role.name }}
				</option>
			</select>
		</label>
	</div>

	<div id="users-search" class="mb-3">
		<label for="users-search" class="me-3">
			<p class="fw-bold">Buscar por nombre:</p>
			<input type="text" class="form-control" [(ngModel)]="searchName">
		</label>
		<button class="btn btn-primary me-3" (click)="getUsers(searchOrg, searchRole, searchName)">
			<i class="fas fa-search"></i>
		</button>
		<button class="btn btn-danger me-3" (click)="searchName = ''; getUsers(searchOrg, searchRole)">
			<i class="fas fa-trash"></i>
		</button>
	</div>

	<div id="users-admin-table-container">

		<div id="users-empty" *ngIf="users.length === 0">
			<p>No se han encontrado usuarios.</p>
		</div>

		<div id="user-add-btn" class="mb-3">
			<button class="btn btn-primary" (click)="userFormShow()">
				<i class="fa fa-user-plus"></i>
				<span>Añadir usuario</span>
			</button>
		</div>

		<table id="users-admin-table" class="table" *ngIf="users.length > 0">
			<thead>
				<tr>
					<th>Editar</th>
					<th>Eliminar</th>
					<th>Ver permisos</th>
					<th>ID</th>
					<th>Nombre</th>
					<th>Apellido</th>
					<th>Organización</th>
					<th>Rol</th>
					<th>Usuario</th>
					<th>Contraseña</th>
					<th>Cerrado</th>
					<th>Acceso a funciones IA</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let user of users">
					<td>
						<a href="#" (click)="userFormShow(user)">
							<i class="fa fa-edit"></i>
						</a>
					</td>
					<td>
						<a href="#" class="text-danger" (click)="deleteUser(user.id)">
							<i class="fa fa-times"></i>
						</a>
					</td>
					<td>
						<!-- <a href="#">  -->
							<!-- (click)="showUserCoursePermissions(user.id)"> -->
						<!-- </a> -->
						<i class="fa fa-eye"></i>
					</td>
					<td>{{ user.id }}</td>
					<td>{{ user.firstname }}</td>
					<td>{{ user.lastname }}</td>
					<td>{{ user.organization.name }}</td>
					<td>{{ user.role.name }}</td>
					<td>{{ user.username }}</td>
					<td>{{ user.password_visible }}</td>
					<td>
						<a href="#" (click)="closeUser(user)">
							<div *ngIf="user.closed">
								<i class="fas fa-lock"></i>
							</div>
							<div *ngIf="!user.closed">
								<i class="fas fa-lock-open"></i>
							</div>
						</a>
					</td>
					<td>
						<span *ngIf="user.ai">Sí</span>
						<span *ngIf="!user.ai">No</span>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

</div>

<dialog id="user-form-dialog">
	<button class="btn-close float-end" (click)="userFormClose()"></button>

	<form [formGroup]="userFormGroup" (ngSubmit)="userFormSubmit()">
		<h2 *ngIf="userFormGroup.value.id == 0">Añadir nuevo usuario</h2>
		<h2 *ngIf="userFormGroup.value.id != 0">Editar usuario: {{ userFormGroup.value.firstname }} {{ userFormGroup.value.lastname }}</h2>

		<input type="hidden" formControlName="id">
	
		<div class="row mb-3">
			<div class="col">
				<label for="firstname" class="d-block">
					<p class="fw-bold">Nombre:</p>
					<input type="text" formControlName="firstname" class="form-control" required>
				</label>
			</div>
		
			<div class="col">
				<label for="lastname" class="d-block">
					<p class="fw-bold">Apellido:</p>
					<input type="text" formControlName="lastname" class="form-control" required>
				</label>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col">
				<label for="email" class="d-block">
					<p class="fw-bold">E-mail:</p>
					<input type="text" formControlName="email" class="form-control">
				</label>
			</div>

			<div class="col">
				<label for="phone" class="d-block">
					<p class="fw-bold">Teléfono:</p>
					<input type="text" formControlName="phone" class="form-control" pattern="[0-9]{9}">
				</label>
			</div>
		</div>

	
		<div class="row">
			<div class="col">
				<label for="username" class="d-block mb-3">
					<p class="fw-bold">Usuario:</p>
					<input type="text" formControlName="username" class="form-control" required>
				</label>
			</div>
			
			<div class="col">
				<label for="password" class="d-block mb-3">
					<p class="fw-bold">Contraseña:</p>
					<input name="password" [type]="userFormPasswordVisible ? 'text' : 'password'" formControlName="password" class="form-control d-inline-block" required>
					<div class="password-toggle ms-3" (click)="userFormTogglePasswordVisible()" *ngIf="userFormPasswordVisible">
						<i class="fas fa-eye"></i>
					</div>
					<div class="password-toggle ms-3" (click)="userFormTogglePasswordVisible()" *ngIf="!userFormPasswordVisible">
						<i class="fas fa-eye-slash"></i>
					</div>
				</label>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col">
				<label for="organization" class="d-block">
					<p class="fw-bold">Organización:</p>
					<select formControlName="organization" class="form-select" required>
						<option value="0" disabled selected>Seleccione...</option>
						<option *ngFor="let org of orgs" [value]="org.id">
							{{ org.name }}
						</option>
					</select>
				</label>
			</div>
		
			<div class="col">
				<label for="role" class="d-block">
					<p class="fw-bold">Rol:</p>
					<select formControlName="role" class="form-select" required>
						<option value="0" disabled selected>Seleccione...</option>
						<option *ngFor="let role of roles" [value]="role.id">
							{{ role.name }}
						</option>
					</select>
				</label>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col">
				<p class="fw-bold">Acceso a funciones de Inteligencia Artificial:</p>
				<label for="ai-no" class="me-3">
					<input type="radio" formControlName="ai" id="ai-no" [value]="false" class="me-1" required>
					<span class="fw-bold">No</span>
				</label>
				<label for="ai-yes" class="me-3">
					<input type="radio" formControlName="ai" id="ai-yes" [value]="true" class="me-1" required>
					<span class="fw-bold">Sí</span>
				</label>
			</div>
		</div>

		<div class="alert alert-danger" *ngIf="userFormGroup.dirty && !userFormGroup.valid">
			<div>
				<i class="fas fa-times"></i>
				<span>Errores:</span>
			</div>
			<ul>
				<li *ngIf="userFormGroup.controls.firstname.hasError('required')">Se requiere el nombre.</li>
				<li *ngIf="userFormGroup.controls.lastname.hasError('required')">Se requiere el apellido.</li>
				<li *ngIf="userFormGroup.controls.email.hasError('email')">El e-mail no es válido.</li>
				<li *ngIf="userFormGroup.controls.phone.hasError('pattern')">El teléfono debe ser 9 números.</li>
				<li *ngIf="userFormGroup.controls.username.hasError('required')">Se requiere un usuario.</li>
				<li *ngIf="userFormGroup.controls.password.hasError('required')">Se requiere una contraseña.</li>
				<li *ngIf="userFormGroup.controls.organization.hasError('min')">Se requiere seleccionar una organización.</li>
				<li *ngIf="userFormGroup.controls.role.hasError('min')">Se requiere seleccionar un rol.</li>
			</ul>
		</div>

		<div id="status" class="mb-3">
			<div id="loading" *ngIf="userFormLoading">
				<i class="fas fa-spinner fa-spin"></i>
				<span>Procesando...</span>
			</div>
			<div id="success" class="text-success" *ngIf="userFormSuccess">
				<i class="fas fa-check"></i>
				<span>¡Usuario guardado correctamente!</span>
			</div>
			<div id="error" class="text-danger" *ngIf="userFormError">
				<i class="fas fa-times"></i>
				<span>Error</span>
			</div>
		</div>

		<div id="buttons" class="me-3">
			<button class="btn btn-danger me-3" (click)="userFormClose()">
				<i class="fas fa-times"></i>
				<span>Cerrar</span>
			</button>
			<button type="submit" class="btn btn-success me-3">
				<div *ngIf="userFormGroup.value.id == 0">
					<i class="fas fa-user-plus"></i>
					<span>Añadir usuario</span>
				</div>
				<div *ngIf="userFormGroup.value.id != 0">
					<i class="fas fa-save"></i>
					<span>Guardar cambios</span>	
				</div>
			</button>
		</div>
	</form>

</dialog>